import isRepoActive from './isRepoActive.lib.repo';

const hasDriverActiveRepo = (repos) => repos.some((repo) => isRepoActive(repo));

export default hasDriverActiveRepo;
